import { memoize } from 'lodash';
import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';

const defaultValueSizes = {
  small: { w: 'w-36', valueTextSize: 'text-16', labelTextSize: 'text-8' },
  large: { w: 'w-50', valueTextSize: 'text-24', labelTextSize: 'text-10' },
};

export const themes = {
  default: memoize(({ size, color }) => {
    const textColor = color ? color : COLORS.WHITE;
    const textShadow = textColor === COLORS.WHITE ? 'text-shadow-2' : '';
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thItem: `flex flex-col items-center justify-between mx-5 text-center text-${textColor}`,
      thValuesWrapper: 'flex flex-row',
      thLabel: `font-bold leading-1 mb-5 ${textShadow} uppercase ${defaultValueSizes[size].labelTextSize}`,
      thValue: `${defaultValueSizes[size].w} flex font-bold items-center justify-center rounded-4 text-center ${textShadow} leading-tight ${defaultValueSizes[size].valueTextSize}`,
    };
  }),
  timer: memoize(({ color }) => ({
    thRoot: 'flex items-stretch justify-center text-14 mb-15',
    thDescription: `bg-${color} text-white shadow-sm py-5 px-10 mr-10 items-baseline`,
    thItem: `flex flex-row items-center justify-between text-center text-${color}`,
    thLabel: 'items-baseline',
    thValuesWrapper: 'flex flex-row shadow-sm py-5 px-10 w-120 justify-center',
    thValue: 'flex items-center justify-center rounded-4 text-center pl-5',
  })),
  offerPush: ({ color = COLORS.WHITE, bgColor }) => ({
    thRoot: classnames(`rounded-pill px-10 py-5 font-sans text-12 font-bold text-${color}`, {
      [`bg-${bgColor}`]: !!bgColor,
    }),
    thItem: `inline mx-1 text-center text-${color} uppercase`,
    thValuesWrapper: 'flex flex-row py-1',
    thLabel: 'inline',
    thValue: 'inline w-auto',
  }),
  infoBanner: () => ({
    thRoot: 'font-brand px-5 rounded-2',
    thItem: 'flex mx-1 text-center text-14 uppercase',
    thValuesWrapper: 'flex flex-row',
    thLabel: 'inline',
    thValue: 'inline w-20',
  }),
  push: memoize(({ color }) => ({
    thRoot: `font-brand text-${color} text-18 uppercase`,
    thValuesWrapper: 'flex',
    thItem: 'flex items-center leading-1 mx-2',
  })),
  options: memoize(({ color }) => ({
    thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
    thDescription: 'font-bold text-saffron py-5 items-baseline',
    thItem: `flex flex-row items-baseline justify-between text-center text-${color}`,
    thLabel: 'items-baseline text-14',
    thValuesWrapper: 'flex flex-row font-bold text-14 items-center',
    thValue: 'flex items-center justify-center rounded-4 text-center pl-5 text-14',
  })),
  optionDetails: memoize(({ bgColor = COLORS.PEARL, color = COLORS.BLACK }) => ({
    thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
    thDescription: 'font-bold text-black py-5 items-baseline',
    thItem: `flex flex-col items-center text-${color} bg-${bgColor} min-w-50 p-5 rounded-8`,
    thLabel: 'items-baseline text-10 text-black',
    thValuesWrapper: 'flex flex-row font-bold gap-5 text-18 items-center',
    thValue: 'flex items-center justify-center text-center text-18',
  })),
};
